import { createReducer } from 'redux-act';

export default createReducer<UI>({}, {});

// types
import type { UI } from '@/store/index';
